module.exports = __webpack_public_path__ + "media/newstyle/images/happy-man-using-his-tablet-home-couch_4-9f1badb69ccb334025603216ff4bb899.png";